<template>
	<section class="press page text-center">

    <ul class="mauto w90">
      <li v-for="(item, index) in press"
          :key="index">
        <a class="pointer" :href="item.url" target="_blank">
          {{ item.title }}
          <figure v-if="item.imgUrl"
                  class="mtop20px">
            <img class="w100" :src="item.imgUrl"
                 alt="">
          </figure>
          <br>
        </a>
        <hr>
      </li>
    </ul>

	</section>
</template>

<script>
	import { mapState } from 'vuex'
	export default {
		name: 'press',
		computed: {
			...mapState({
        press: 'press'
      })
		},
		methods: {

		}
	}
</script>

<style lang="less">
	.press {
    padding-top: 120px;
    ul {
      max-width: 600px;
    }
    a {
      font-size: 2rem;
    }
    a:hover {
      color: #50c607;
    }
	}
</style>
